import { render, staticRenderFns } from "./departStatistic.vue?vue&type=template&id=bdb2c8da"
import script from "./departStatistic.vue?vue&type=script&lang=js"
export * from "./departStatistic.vue?vue&type=script&lang=js"
import style0 from "./departStatistic.vue?vue&type=style&index=0&id=bdb2c8da&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports